/******************************************************************************
 * 
 * Strauss Motion
 * 
 * Copyright (c) 2022 Robimo GmbH
 *
 * Authors: Daniel Martinek
 *
 *****************************************************************************/

import { connect } from 'react-redux'
import { ApplicationState } from '../store/interfaces';

import { LinkFooter } from '../components/LinkFooter'

const mapStateToProps = (state: ApplicationState) => {
    return {
        country: state.ui.country
    }
}

const LinkFooterContainer = connect(
    mapStateToProps
)(LinkFooter)

export default LinkFooterContainer